import notify from 'devextreme/ui/notify';

export default function miToast(type: 'INFO' | 'SUCCESS' | 'WARNING' | 'ERROR', message: string , timeInSeconds: number) {
    notify({
        message,
        type,
        displayTime: timeInSeconds*1000,
        closeOnClick: true,        
        animation: {
            show: {
                type: 'fade', duration: 400, from: 0, to: 1,
            },
            hide: { type: 'fade', duration: 400, to: 0 },
        },
    },
    {
        position: 'bottom right',        
        direction: 'up-stack'
    })
}
